import React from 'react'
import { useSelector } from 'react-redux'

const NoDataImage = ({ imageURL, height, width }) => {
  const { featureProps } = useSelector((state) => state.common)
  const { mode, searcheURLAuthor, searchURLPublish } = featureProps

  const callToNavigate = () => {
    window.location.href = `${
      mode === 'publish' ? searchURLPublish : `${searcheURLAuthor}.html`
    }`
  }
  const style = {}
  if (height) style.height = height
  if (width) style.width = width

  return (
    <div className="aem-Grid">
      <div
        className="no-data-msg"
        style={Object.keys(style).length > 0 ? style : null}
      >
        <h3 className="no-data-msg__title">
          This section will include data when available
        </h3>
        <div>
          <img src={imageURL} alt="Data is not available search icon" />
        </div>

        <div className="button tui__btn lp__solid_lightblue_btn">
          <button
            type="button"
            className="cmp-button tui__btn_lg"
            onClick={() => callToNavigate()}
          >
            <span className="cmp-button__text">Data &amp; Resources</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default NoDataImage
